import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  OnInit,
  ViewEncapsulation
} from '@angular/core';
import { AppFile } from 'taxtank-core';
import {
  AbstractFileUploaderControlComponent
} from '@shared/component/form-controls/file/abstract-file-uploader-control/abstract-file-uploader-control.component';

/**
 * @todo: taxtankit TT-3809 split on multiple/single upload
 * File upload component based on Prime file uploader
 * https://primeng.org/fileupload
 */
@Component({
  selector: 'app-file-uploader',
  templateUrl: '../abstract-file-uploader-control/abstract-file-uploader-control.component.html',
  styleUrl: '../abstract-file-uploader-control/abstract-file-uploader-control.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class FileUploaderComponent extends AbstractFileUploaderControlComponent<AppFile> implements OnInit, AfterViewInit {

  protected updateValue(files: AppFile[]): void {
    this.value = files[0];
  }

  protected get isEmpty(): boolean {
    return !this.value;
  }
}
